export default __webpack_public_path__ + "static/media/child.bf4e818b.png";